<template>
	<div v-if="data != null">
		{{ data }}
	</div>
	<div v-else class="text-muted">-</div>
</template>

<script>
	export default {
		props: {
			data: {
				required: true,
			},
		},
	};
</script>
